(() => {
  const PARAM_NAME = 'aff';
  const ATTRIBUTE_NAME = 'affiliate_code';
  const STORAGE_KEY = 'oryzae_affiliate_code';
  const EXPIRES_KEY = 'oryzae_affiliate_code_expires_at';
  const COOKIE_NAME = 'oryzae_affiliate_code';
  const COOKIE_DAYS = 30;
  const MAX_CODE_LENGTH = 80;
  const CODE_PATTERN = /^[A-Za-z0-9_-]+$/;

  function now() {
    return Date.now();
  }

  function sanitizeAffiliateCode(value) {
    if (typeof value !== 'string') return '';

    const code = value.trim();
    if (!code || code.length > MAX_CODE_LENGTH || !CODE_PATTERN.test(code)) return '';

    return code;
  }

  function getAffiliateCodeFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      return sanitizeAffiliateCode(params.get(PARAM_NAME) || '');
    } catch (error) {
      return '';
    }
  }

  function getExpiresAt() {
    return now() + COOKIE_DAYS * 24 * 60 * 60 * 1000;
  }

  function setCookie(code, expiresAt) {
    try {
      const maxAge = Math.max(0, Math.floor((expiresAt - now()) / 1000));
      document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)}; Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;
    } catch (error) {
      // Cookieが使えない環境ではlocalStorageだけで継続する。
    }
  }

  function getCookie() {
    try {
      const cookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${COOKIE_NAME}=`));

      if (!cookie) return '';

      return sanitizeAffiliateCode(decodeURIComponent(cookie.split('=').slice(1).join('=')));
    } catch (error) {
      return '';
    }
  }

  function saveAffiliateCode(code) {
    const expiresAt = getExpiresAt();

    try {
      localStorage.setItem(STORAGE_KEY, code);
      localStorage.setItem(EXPIRES_KEY, String(expiresAt));

      // Affiliate優先。Pay Forwardの紹介コードが同一ブラウザに残っていても、同一注文の二重成果にしない。
      localStorage.removeItem('payforward_ref');
    } catch (error) {
      // Safariプライベートブラウズ等ではlocalStorageが失敗することがある。
    }

    setCookie(code, expiresAt);
  }

  function getStoredAffiliateCode() {
    try {
      const code = sanitizeAffiliateCode(localStorage.getItem(STORAGE_KEY) || '');
      const expiresAt = Number(localStorage.getItem(EXPIRES_KEY) || '0');

      if (code && expiresAt && expiresAt > now()) return code;

      if (code || expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(EXPIRES_KEY);
      }
    } catch (error) {
      // localStorage不可の場合はcookieへfallbackする。
    }

    return getCookie();
  }

  async function updateCartAttribute(code) {
    const affiliateCode = sanitizeAffiliateCode(code);
    if (!affiliateCode || typeof fetch !== 'function') return false;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [ATTRIBUTE_NAME]: affiliateCode
          }
        })
      });

      return response.ok;
    } catch (error) {
      return false;
    }
  }

  function syncAffiliateCodeToCart(code) {
    const affiliateCode = sanitizeAffiliateCode(code);
    if (!affiliateCode) return;

    updateCartAttribute(affiliateCode).then((ok) => {
      if (ok) {
        window.dispatchEvent(new CustomEvent('oryzae:affiliate-code-synced', {
          detail: { affiliateCode }
        }));
      }
    });
  }

  function initAffiliateTracking() {
    const urlCode = getAffiliateCodeFromUrl();
    const affiliateCode = urlCode || getStoredAffiliateCode();

    if (!affiliateCode) return;

    if (urlCode) saveAffiliateCode(urlCode);
    syncAffiliateCodeToCart(affiliateCode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAffiliateTracking, { once: true });
  } else {
    initAffiliateTracking();
  }
})();
